import { resolve } from 'path';

import type { CommonResponse } from '@/utils/request';
import { Request } from '@/utils/request';

interface IParam {
  sessionId: string;
  messageId: string;
}

function StopMsg(data: IParam) {
  return Request<CommonResponse<any>>({
    url: '/rest/general/message/stop',
    method: 'post',
    data
  }).then((res) => {
    if (res.data.code !== 0) {
      console.error('/rest/general/message/stop', res.data.message);
      resolve(res.data.data);
    }
  });
}

export default StopMsg;
